import React from 'react';
import { useUserAuthentication } from '@ohif/ui';

//console.log('platform/viewer/src/routes/PrivateRoute.tsx');

export const PrivateRoute = ({ children, handleUnauthenticated }) => {
  const [{ user, enabled }] = useUserAuthentication();

  if (enabled && !user) {
    return handleUnauthenticated();
  }

  return children;
};

export default PrivateRoute;
